import { ICategory, ICategoryCreate, ICategoryUpdate } from '../typing/category.interface';

export class Category {
    data: ICategory;

    constructor(data: ICategory){
        this.data = data;
    }

    dataForCreate(formData: ICategoryCreate): ICategoryCreate{
        return {
            name: formData.name,
            customId: formData.customId || null,
            equipmentExTableName: formData.equipmentExTableName || null,
            // companyId: formData.companyId,
        };
    }

    dataForUpdate(formData: ICategoryCreate): ICategoryUpdate {
        return {
            id: this.data.id,
            name: formData.name,
            customId: formData.customId || null,
            equipmentExTableName: formData.equipmentExTableName || null,
            // companyId: formData.companyId,
        };
    }

    formData(): ICategoryCreate {
        return {
            name: this.data.name,
            customId: this.data.customId,
            equipmentExTableName: this.data.equipmentExTableName,
            // companyId: this.data.company?.id,
        };
    }
}
